import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import {
  cancelButtonStyle,
  primaryButtonStyle,
} from "../../styles/buttonStyles";

interface DeleteConfirmationDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void | Promise<void>;
  title: string;
  message: string;
  isLoading?: boolean;
}

export const DeleteConfirmationDialog: React.FC<
  DeleteConfirmationDialogProps
> = ({ open, onClose, onConfirm, title, message, isLoading = false }) => {
  const handleConfirm = async () => {
    await onConfirm();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      sx={{
        "& .MuiDialog-paper": {
          overflow: "hidden", // Prevent scrollbar outside modal
        },
      }}
    >
      <DialogTitle sx={{ px: 4, pt: 4, pb: 2 }}>{title}</DialogTitle>
      <DialogContent
        sx={{
          px: 4,
          py: 2,
          overflowY: "auto", // Enable scrolling within content
          overflowX: "hidden", // Prevent horizontal scroll
          maxHeight: "calc(100vh - 200px)", // Limit height to viewport
          "&::-webkit-scrollbar": {
            width: "8px",
          },
          "&::-webkit-scrollbar-track": {
            background: "transparent",
          },
          "&::-webkit-scrollbar-thumb": {
            background: "rgba(0, 0, 0, 0.2)",
            borderRadius: "4px",
            "&:hover": {
              background: "rgba(0, 0, 0, 0.3)",
            },
          },
        }}
      >
        <Typography>{message}</Typography>
      </DialogContent>
      <DialogActions sx={{ gap: 3, px: 4, py: 3 }}>
        <Button
          onClick={onClose}
          disabled={isLoading}
          disableRipple
          sx={cancelButtonStyle}
        >
          Cancel
        </Button>
        <LoadingButton
          onClick={handleConfirm}
          loading={isLoading}
          disabled={isLoading}
          color="error"
          sx={primaryButtonStyle}
        >
          Delete
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};
